





















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY, store } from './_store';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'form', 'meta', 'shift_plans'
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      plan_id: { required },
      quantity: { required },
      product_container_id: { required },
    }
    return {
      form: rules
    }
  },
})
export default class ShiftCustomFactSemiForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;
  @Prop({ type: String }) documentId!: any;

  document!: any
  form!: any
  shift_plans!: any[]

  public product_id: any = null;

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.$store.dispatch(`${STORE_KEY}/loadShiftPlans`, {
      documentId: this.documentId
    })
    .then((plans: any[]) => {
      this.restoreProductFromPlan(plans);
    });

    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams)
        .then(() => {
          this.restoreProductFromPlan(this.shift_plans);
        });
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id
      })
      .then(() => {
        this.restoreProductFromPlan(this.shift_plans);
      });
    }
  }

  restoreProductFromPlan(plans: any[]) {
    if (this.product_id || !this.form || !this.form.plan_id) {
      return;
    }
    const plan = (plans || []).find((item: any) => item.id === this.form.plan_id);
    this.product_id = plan ? plan.product_id : null;
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });
  }

  onPlanSelect(planId: any) {
    const plan = this.shift_plans.find((item: any) => item.id === planId);
    this.changeValue('plan_id', planId);

    const pc_id = this.form.product_container_id;
    this.product_id = plan ? plan.product_id : null;
    setTimeout(() => {
      this.changeValue('product_container_id', pc_id)
    }, 100)
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
  }
}

